import localStorageEnum from '../../../enums/localStorageEnum'

export const redirectionVersAcquisitionResidence = (lang: string) => {
	// On retire le step du localStorage pour que le check-selection détermine la bonne étape du dossier à afficher à l'utilisateur sur Acquisition Résidence
	localStorage.removeItem(localStorageEnum.step)

	const acquisition_residence_uri = JSON.parse(localStorage.getItem('commonUri') || '').acquisition_residence_uri
	window.location.href = `${acquisition_residence_uri}/${lang}/check-selection`
}
